import { getNearestSunday, getWeekAfterStartDate, redistributeChapters } from './';

export const updateDates = (tree: any, setTreeData: Function, phaseIndex: number, newEndDate: Date, parent: any) => {
  const { phases } = tree;
  let clonePhases = JSON.parse(JSON.stringify(phases));
  const isSunday = newEndDate.getDay() === 0;
  let weekFormat = '';
  if (isSunday) {
    weekFormat = 'mondayToSunday';
    for (const phase of clonePhases) {
      redistributeChapters(phase, weekFormat);
    }
    changeDatesToSunday(clonePhases);
  } else {
    weekFormat = 'weekly';
    for (const phase of clonePhases) {
      redistributeChapters(phase, weekFormat);
    }
    changeDatesToWeekly(clonePhases);
  }

  //update all data with moved syllabus
  let cloneTree = JSON.parse(JSON.stringify(tree));
  cloneTree = { ...cloneTree, phases: JSON.parse(JSON.stringify(clonePhases)), weekFormat };
  setTreeData({ treeData: cloneTree });
};

const changeDatesToSunday = (clonePhases: any) => {
  let weekNo = 1;
  clonePhases.forEach((phase: any) => {
    let { startDate } = phase;
    phase.weeks.forEach((week: any) => {
      week.startDate = startDate;
      week.weekNo = weekNo++;
      let endDate = getNearestSunday(startDate);
      week.endDate = getNearestSunday(startDate);
      startDate = new Date(endDate.setDate(endDate.getDate() + 1));
    });
    phase.weeks[phase.weeks.length - 1].endDate = phase.endDate;
  });
};

const changeDatesToWeekly = (clonePhases: any) => {
  let weekNo = 1;
  clonePhases.forEach((phase: any) => {
    let { startDate } = phase;
    phase.weeks.forEach((week: any) => {
      week.startDate = startDate;
      week.weekNo = weekNo++;
      let endDate = getWeekAfterStartDate(startDate);
      week.endDate = endDate;
      startDate = new Date(endDate.setDate(endDate.getDate() + 1));
    });
    phase.weeks[phase.weeks.length - 1].endDate = phase.endDate;
  });
};
